export const enum HttpMethod {
	DELETE = "DELETE",
	GET = "GET",
	HEAD = "HEAD",
	PATCH = "PATCH",
	POST = "POST",
	PUT = "PUT",
	OPTIONS = "OPTIONS"
}
